import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "SystemDetails",
    component: () => (__SERVER__ ? require("./system-details-view") : import("./system-details-view"))
});

export default definition;
